"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistSubmissionBadge } from "@/components/waves/drops/ArtistSubmissionBadge";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
import { ProfileWinnerBadge } from "@/components/waves/drops/ProfileWinnerBadge";
import { useArtistPreviewModal } from "@/hooks/useArtistPreviewModal";
interface MemesLeaderboardDropArtistInfoProps {
  readonly drop: ExtendedDrop;
}
const MemesLeaderboardDropArtistInfo = t0 => {
  const $ = _c(41);
  const {
    drop
  } = t0;
  const {
    isModalOpen,
    modalInitialTab,
    handleBadgeClick,
    handleModalClose
  } = useArtistPreviewModal();
  const submissionCount = drop.author.active_main_stage_submission_ids?.length || 0;
  const hasSubmissions = submissionCount > 0;
  const winnerCount = drop.author.winner_main_stage_drop_ids?.length || 0;
  const isWinner = winnerCount > 0;
  let t1;
  if ($[0] !== drop) {
    t1 = <WaveDropAuthorPfp drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop.author.level) {
    t2 = !!drop.author?.level && <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[2] = drop.author.level;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== drop.author.handle || $[5] !== drop.author.id) {
    t3 = drop.author?.handle ? <UserProfileTooltipWrapper user={drop.author.handle ?? drop.author.id}><Link href={`/${drop.author?.handle}`} onClick={_temp} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{drop.author?.handle}</span></Link></UserProfileTooltipWrapper> : <Link href={`/${drop.author?.handle}`} onClick={_temp2} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{drop.author?.handle}</span></Link>;
    $[4] = drop.author.handle;
    $[5] = drop.author.id;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== drop.id || $[8] !== handleBadgeClick || $[9] !== isWinner || $[10] !== winnerCount) {
    t4 = isWinner && <ProfileWinnerBadge winCount={winnerCount} onBadgeClick={() => handleBadgeClick("winners")} tooltipId={`leaderboard-winner-badge-${drop.id}`} />;
    $[7] = drop.id;
    $[8] = handleBadgeClick;
    $[9] = isWinner;
    $[10] = winnerCount;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== drop.id || $[13] !== handleBadgeClick || $[14] !== hasSubmissions || $[15] !== submissionCount) {
    t5 = hasSubmissions && <ArtistSubmissionBadge submissionCount={submissionCount} onBadgeClick={() => handleBadgeClick("active")} tooltipId={`leaderboard-badge-${drop.id}`} />;
    $[12] = drop.id;
    $[13] = handleBadgeClick;
    $[14] = hasSubmissions;
    $[15] = submissionCount;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-text-sm tw-text-iron-500">•</span>;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== drop.created_at) {
    t7 = <WaveDropTime timestamp={drop.created_at} />;
    $[18] = drop.created_at;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-flex-wrap -tw-mt-0.5">{t2}{t3}{t4}{t5}{t6}{t7}</div>;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  const t9 = drop.winning_context?.decision_time || null;
  let t10;
  if ($[26] !== drop.rank || $[27] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-gap-x-2"><WinnerDropBadge rank={drop.rank} decisionTime={t9} /></div>;
    $[26] = drop.rank;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t8) {
    t11 = <div className="tw-flex tw-flex-col tw-justify-between tw-h-12">{t8}{t10}</div>;
    $[29] = t10;
    $[30] = t8;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== drop.author || $[33] !== handleModalClose || $[34] !== isModalOpen || $[35] !== modalInitialTab) {
    t12 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} initialTab={modalInitialTab} />;
    $[32] = drop.author;
    $[33] = handleModalClose;
    $[34] = isModalOpen;
    $[35] = modalInitialTab;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== t1 || $[38] !== t11 || $[39] !== t12) {
    t13 = <div className="tw-flex tw-gap-x-3">{t1}{t11}{t12}</div>;
    $[37] = t1;
    $[38] = t11;
    $[39] = t12;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  return t13;
};
export default MemesLeaderboardDropArtistInfo;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}